<script setup lang="ts">
defineProps<{
    title: string;
    items: {
        uri?: string;
        to?: { name: string };
        linkText: string;
    }[];
}>();
</script>

<template>
    <div>
        <h2 class="fw-bold mb-0">{{ title }}</h2>
        <ul class="pt-0 mb-0">
            <li v-for="(item, index) in items" :key="index">
                <slot name="item" v-bind="item"></slot>
            </li>
        </ul>
    </div>
</template>

<style scoped lang="scss">
h2 {
    padding-top: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
    font-size: 1rem;
    line-height: var(--bs-body-line-height);
}

ul {
    list-style-image: none;
    list-style-position: outside;
    list-style-type: none;
    padding: 0.5rem 0;
}

:slotted(a) {
    display: block;
    width: 100%;
    padding-right: 1rem;
    font-weight: 400;
    text-decoration: none;
    color: var(--bs-dropdown-link-color);

    &:hover {
    text-decoration: underline;
    }
}
</style>
